module.exports = "https://web-assets-production.autolist.com/_next/static/images/coupe-angled-71d36f8ca22e042879f7928f2e125c45.jpg";